import TableView from "./TableView";
import BarChartView from "./BarChartView";

/**
 * Registry of available analytics visualizations.
 * Adding a new chart type requires only a new component + one line here.
 */
const chartRegistry = {
  table: { label: "Table", component: TableView },
  bar: { label: "Bar Chart", component: BarChartView },
};

export default chartRegistry;
